
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Translation } from '../Configure';
import { LocaleStringResource, TranslationApiUiClient, TranslationRequest } from '../../../backend/backendapi';
import { initClient } from '../../../../api';

@Component
export default class TranslationEditorLocale extends Vue {
  @Prop({ required: true })
  translation!: Translation;
  @Prop({ required: true })
  locale!: string;
  @Prop({ required: true })
  editInherited!: boolean;

  private readonly api = initClient(TranslationApiUiClient);
  private mapUpdateTrigger = false; // vue reactivity seemingly does not cover map entry updates, so we use a trigger here

  get placeholder(): string {
    return this.inherited?.resourceValue ?? '';
  }

  get value(): string {
    if (this.editInherited) {
      return this.inherited?.resourceValue ?? '';
    } else {
      return this.selected?.resourceValue ?? '';
    }
  }

  set value(value: string) {
    if (this.editInherited) {
      if (!this.inherited) {
        this.translation.inheritedTranslations.set(this.locale, new LocaleStringResource({
          resourceName: this.translation.resourceName,
          resourceValue: value,
        }));
      }
      this.translation.inheritedTranslations.get(this.locale)!.resourceValue = value;
      this.mapUpdateTrigger = !this.mapUpdateTrigger; // trigger getter recomputation
    } else {
      if (!this.selected) {
        this.translation.translations.set(this.locale, new LocaleStringResource({ resourceName: this.translation.resourceName, resourceValue: value }));
      }
      const get = this.translation.translations.get(this.locale)!;
      if (get.resourceValue !== value) {
        get.resourceValue = value;
      }
      this.mapUpdateTrigger = !this.mapUpdateTrigger; // trigger getter recomputation
    }
  }

  get inherited(): LocaleStringResource | null {
    this.mapUpdateTrigger; //this will recompute this getter when the variable changes
    return this.translation.inheritedTranslations.get(this.locale) ?? null;
  }

  get selected(): LocaleStringResource | null {
    this.mapUpdateTrigger; //this will recompute this getter when the variable changes
    return this.translation.translations.get(this.locale) ?? null;
  }

  async autoTranslate(): Promise<void> {
    let fromLocale = 'en-US';
    let toTranslate: string;
    if (this.editInherited) {
      toTranslate = this.translation.inheritedTranslations.get(fromLocale)?.resourceValue;
      if (!toTranslate) {
        fromLocale = [...this.translation.inheritedTranslations.entries()].filter(e => e[0] != 'en-US' && !!e[1].resourceValue.trim())[0][0];
        toTranslate = this.translation.inheritedTranslations.get(fromLocale)?.resourceValue;
      }
    } else {
      toTranslate = this.translation.translations.get(fromLocale)?.resourceValue;
      if (!toTranslate) {
        fromLocale = [...this.translation.translations.entries()].filter(e => e[0] != 'en-US' && !!e[1].resourceValue.trim())[0][0];
        toTranslate = this.translation.translations.get(fromLocale)?.resourceValue;
      }
    }

    if (!toTranslate || fromLocale === this.locale) {
      return;
    }

    const result = await this.api.translate(new TranslationRequest({
      toTranslate: [toTranslate],
      toLocale: this.locale,
      fromLocale: fromLocale,
    }));

    this.value = result.fromTranslate[0];
  }
}
